// extracted by css-extract-rspack-plugin
export default {"gameLayer":"w7t1tY","main":"AqrgSE","bgContainer":"Kpb7EM","bgItem":"jINxZ9","active":"IFGkuM","loading":"T9sePu","lobby":"W9VbiN","game":"RoHsaA","gameSpecial":"FK8dpu"};